import Image from 'next/image'
import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {getPricingContent} from '@/content/pricing'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

export const PricingHeroBenefits: FC = () => {
  const {t} = useTranslation()
  const {benefits} = getPricingContent()

  return (
    <>
      <ul className="list">
        {benefits.map(({title, description, imageSrc, imageAlt}, i) => (
          <li key={i} className="item">
            <div className="icon">
              <Image src={imageSrc} alt={imageAlt} width={40} height={40} />
            </div>
            <Text fontWeight={TextFontWeight.bold} color={theme.palette.warning.contrastText}>
              {t(title)}
            </Text>
            <Text variant={TextVariant.text14} color={theme.palette.warning.contrastText}>
              {t(description)}
            </Text>
          </li>
        ))}
      </ul>

      <style jsx>{`
        .list {
          display: flex;
          gap: ${theme.spacing[5.5]};
          padding: ${theme.spacing[6]} 0;
        }
        .item {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: ${theme.spacing[1]};
          align-items: center;
          text-align: center;
        }
        .icon {
          display: flex;
          margin-bottom: ${theme.spacing[2.5]};
        }
        @media ${MOBILE_SCREENSIZE} {
          .list {
            flex-direction: column;
            padding: ${theme.spacing[5.5]} ${theme.spacing[3]};
            gap: ${theme.spacing[5]};
          }
          .icon {
            margin-bottom: ${theme.spacing[1]};
          }
        }
      `}</style>
    </>
  )
}
